import React, { useState, useEffect, useMemo } from "react";
import ImageBase from "../../common/Control/ImageBase";
import { connect, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { Breadcrumb } from "antd";
import { HomeOutlined } from "@ant-design/icons";
import "./PageTopBar.scss";
const PageTopBar = (props) => {
  const [pathName, setPathname] = useState("");
  const menusImmutable = useSelector((state) => state.menuReducer.get("menus"));
  const menusSelector = useMemo(() => {
    return menusImmutable ? menusImmutable.toJS() : [];
  }, [menusImmutable]);
  useEffect(() => {
    let pathNameTemp = props.location.pathname;
    setPathname(pathNameTemp);
  }, [props.location.pathname]);

  const getBreadcrumbItems = () => {
    const currentPage = menusSelector.find((x) => x.path === pathName);
    const currentTitle = currentPage?.name;
    // lấy menu cha nếu có
    let parentMenu = menusSelector.find((x) => x.id === currentPage?.parent_id);
    if (!parentMenu)
      parentMenu = menusSelector.find(
        (x) => x.id == currentPage?.section_id && x.parent_id == null
      );
    return (
      <>
        <Breadcrumb.Item>
          <a href={parentMenu ? parentMenu.path : "/"}>
            {/* <HomeOutlined /> Trang chủ */}
            {parentMenu && parentMenu.icon ? (
              <i className={parentMenu.icon}></i>
            ) : null}{" "}
            {parentMenu ? parentMenu.name : "Trang không xác định"}
          </a>
        </Breadcrumb.Item>
        <Breadcrumb.Item>{currentTitle}</Breadcrumb.Item>
      </>
    );
  };

  return (
    <div className="page-topbar">
      <div className="page-topbar-content">
        <Breadcrumb>{getBreadcrumbItems()}</Breadcrumb>
      </div>
    </div>
  );
};

export default connect(null, null)(withRouter(PageTopBar));
